import { Deserializable } from '../protocols/deserializable';
import { AnnuityPensionAccountDetails } from './annuity-pension-account-details';

export class AnnuityPensionAccountActionResponse implements Deserializable {
  public warnings: string[] = [];
  public accountDetails!: AnnuityPensionAccountDetails;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    this.accountDetails = Deserialize.instanceOf(AnnuityPensionAccountDetails, this.accountDetails);
  }
}
